export { outlineDom } from './config.ts'
export { setupOutline } from './outlineController.ts'
export type { OutlineOptions } from './types.ts'
